import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { API_BASE_URL } from "src/app/injection-constants";
import { AppFilterModel } from "../models/section-configuration.model";
import { PagedResponse } from "../models/paged-response";
import { AppFilterRequest } from "../../shared/models/app-filter.request";
import { App } from "../../shared/models/app.model";


@Injectable({
    providedIn: 'root',
})
export class AppService {
    constructor(private readonly http: HttpClient,
        @Inject(API_BASE_URL) private readonly apiBaseUrl: string) { }

        getSectionApps(filter: AppFilterModel): Observable<App[]> {
            const filterRequest: AppFilterRequest = {
                filter: {...filter,
                    country: null,
                    searchTerm: null,
                    includeHidden: true,
                    isSupportMode: true
                },
                pageSize: 100,
                nextPage: ''
            };

            return this.http.post<PagedResponse<App>>(`${this.apiBaseUrl}/apps/search`, filterRequest).pipe(
                map(response => {
                    return response.items;
                })
            );
        }

}
